import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useWallet } from '../context/WalletContext';
import '../styles/mobile-navigation.css';

/**
 * Mobile Navigation Component
 * This component handles the responsive navigation menu for mobile devices
 */
const MobileNavigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { wallet, openWalletModal, disconnectWallet } = useWallet();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest('.mobile-navigation') && !event.target.closest('.menu-toggle')) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    
    // Prevent scrolling when menu is open
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  // Format wallet address for display
  const formatWalletAddress = (address) => {
    if (!address) return '';
    return address.substring(0, 6) + '...' + address.substring(address.length - 4);
  };

  return (
    <div className="mobile-navigation">
      {/* Hamburger Button */}
      <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
        <span className={`menu-icon ${isOpen ? 'open' : ''}`}></span>
      </button>
      
      {/* Mobile Menu */}
      <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
        <div className="mobile-menu-container">
          <nav className="mobile-nav-links">
            <a href="/#features" className="mobile-nav-link" onClick={toggleMenu}>Features</a>
            <a href="/#rwa-explanation" className="mobile-nav-link" onClick={toggleMenu}>RWA Explained</a>
            <a href="/#tokenomics" className="mobile-nav-link" onClick={toggleMenu}>Tokenomics</a>
            <a href="/#products" className="mobile-nav-link" onClick={toggleMenu}>Devices</a>
            <Link to="/node" className="mobile-nav-link" onClick={toggleMenu}>Node Overview</Link>
            <Link to="/node#node-stats" className="mobile-nav-link" onClick={toggleMenu}>Node Stats</Link>
            <Link to="/node#node-leaderboard" className="mobile-nav-link" onClick={toggleMenu}>Node Leaderboard</Link>
            <Link to="/node#node-governance" className="mobile-nav-link" onClick={toggleMenu}>Node Governance</Link>
            <Link to="/node#node-calculator" className="mobile-nav-link" onClick={toggleMenu}>Earnings Calculator</Link>
            <Link to="/node#node-application" className="mobile-nav-link" onClick={toggleMenu}>Apply for Node</Link>
            <a href="/#faq" className="mobile-nav-link" onClick={toggleMenu}>FAQ</a>
          </nav>
          
          {/* Wallet Button */}
          <div className="mobile-wallet-button">
            {wallet.connected ? (
              <div className="wallet-info-button">
                <div className="wallet-address-display">
                  {wallet.type === 'okx' && (
                    <div className="wallet-icon okx">
                      <svg width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="32" height="32" rx="6" fill="#000"/>
                        <path d="M23 9H17V15H23V9Z" fill="#8C8C8C"/>
                        <path d="M15 9H9V15H15V9Z" fill="#8C8C8C"/>
                        <path d="M23 17H17V23H23V17Z" fill="#8C8C8C"/>
                        <path d="M15 17H9V23H15V17Z" fill="#8C8C8C"/>
                      </svg>
                    </div>
                  )}
                  {wallet.type === 'binance' && (
                    <div className="wallet-icon binance">
                      <svg width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="32" height="32" rx="6" fill="#F0B90B"/>
                        <path d="M16 7L18.5 9.5L13.5 14.5L11 12L16 7Z" fill="white"/>
                        <path d="M19.5 10.5L22 13L13.5 21.5L11 19L19.5 10.5Z" fill="white"/>
                        <path d="M10 13L12.5 15.5L10 18L7.5 15.5L10 13Z" fill="white"/>
                        <path d="M22 19L24.5 21.5L22 24L19.5 21.5L22 19Z" fill="white"/>
                      </svg>
                    </div>
                  )}
                  {wallet.type === 'metamask' && (
                    <div className="wallet-icon metamask">
                      <svg width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M27.5933 3L17.6 11.1867L19.4133 6.4L27.5933 3Z" fill="#E17726"/>
                        <path d="M4.4 3L14.3067 11.28L12.5867 6.4L4.4 3Z" fill="#E27625"/>
                        <path d="M23.8933 21.6133L21.0667 25.9867L26.96 27.6267L28.6667 21.7067L23.8933 21.6133Z" fill="#E27625"/>
                        <path d="M3.34666 21.7067L5.04 27.6267L10.9333 25.9867L8.10666 21.6133L3.34666 21.7067Z" fill="#E27625"/>
                      </svg>
                    </div>
                  )}
                  <span>{formatWalletAddress(wallet.address)}</span>
                </div>
                <div className="wallet-actions">
                  <div className="wallet-balance">{wallet.balance} USDT</div>
                  <button className="disconnect-button" onClick={disconnectWallet}>
                    Disconnect
                  </button>
                </div>
              </div>
            ) : (
              <button className="connect-wallet-button" onClick={openWalletModal}>
                Connect Wallet
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileNavigation;
